import React from "react";
import { useDispatch } from "react-redux";
import styled from "@emotion/styled";
import DefaultOrangeButton from "@modules/Components/DefaultOrangeButton";
import { useHistory } from "react-router-dom";
import { closeModal } from "./action";
import { defaultAction } from "@actions/defaultAction";
import { HIDE_LOADING } from "@constants/actionTypes";

const Header = styled.div`
  font-size: 30px;
  font-weight: 500;
  text-align: center;
  color: #1f2021;
`;

const CompleteHeader = styled(Header)`
  padding-top: 25px;
`;

const Text = styled.div`
  font-size: 16px;
  line-height: 1.75;
  text-align: center;
  color: #777984;
  max-width: 455px;
  margin: 0 auto;
  padding-top: 18px;
  padding-bottom: 35px;

  @media (max-width: 525px) {
    font-size: 15px;
  }
`;

const ButtonContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding-bottom: 50px;
`;

const VerificationComplete = ({ closable, page }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <div className="verification-complete">
      <CompleteHeader>Verification Complete 🎉</CompleteHeader>
      <Text>Your phone number is verified.</Text>
      <ButtonContainer>
        <DefaultOrangeButton
          handleClick={() => {
            if (page) {
              history.push("/");
            } else {
              dispatch(closeModal());
              if (!closable) {
                dispatch(defaultAction(HIDE_LOADING));
                history.push("/order-complete/");
              }
            }
          }}
          classes={"main-default-orange-button"}
        >
          <span>Done</span>
        </DefaultOrangeButton>
      </ButtonContainer>
    </div>
  );
};

export default VerificationComplete;
